<template>
    <div class="index h-full">
        <van-nav-bar left-text="返回" left-arrow @click-left="back" />
        <VideoPlayer
            v-if="courseInfo.video_file"
            :url="courseInfo.video_file"
            @play-start="handlePlayStart"
            @play-end="handlePlayEnd"
        />
        <div class="lesson-title">
            <div
                v-if="courseInfo.lesson_title"
                class="w-full"
                style="display: flex; justify-content: space-between"
            >
                <div>{{ courseInfo.lesson_title }}</div>
                <div v-if="is_recharge_type == 1&&userDatalt.isDealer" style="display: flex;">
                    <div class="lesson-edit" @click="toggleEdit">
                        {{ isEditing ? "完成" : "编辑" }}
                    </div>
                    <div class="lesson-cancel" v-if="isEditing" @click="cancelEdit">取消</div>
                </div>
            </div>
            <template v-if="is_recharge_type == 1&&userDatalt.isDealer">
                <!-- 开始时间 -->
                <div class="lesson-time">
                    <span>开始时间：</span>
                    <span v-if="!isEditing">{{
                        courseInfo.train_lesson_start_time
                    }}</span>
                    <div v-else class="time-input-wrapper">
                        <van-field
                            v-model="editForm.start_time"
                            readonly
                            placeholder="请选择开始时间"
                            @click="showStartTimePicker = true"
                            class="time-input"
                        />
                        <van-popup
                            v-model="showStartTimePicker"
                            position="bottom"
                        >
                            <van-datetime-picker
                                v-model="startTimeDate"
                                type="datetime"
                                title="选择开始时间"
                                :formatter="formatter"
                                @confirm="onStartTimeConfirm"
                                @cancel="showStartTimePicker = false"
                            />
                        </van-popup>
                    </div>
                </div>
                <!-- 结束时间 -->
                <div class="lesson-time">
                    <span>结束时间：</span>
                    <span v-if="!isEditing">{{
                        courseInfo.train_lesson_end_time
                    }}</span>
                    <div v-else class="time-input-wrapper">
                        <van-field
                            v-model="editForm.end_time"
                            readonly
                            placeholder="请选择结束时间"
                            @click="showEndTimePicker = true"
                            class="time-input"
                        />
                        <van-popup
                            v-model="showEndTimePicker"
                            position="bottom"
                        >
                            <van-datetime-picker
                                v-model="endTimeDate"
                                type="datetime"
                                title="选择结束时间"
                                :formatter="formatter"
                                @confirm="onEndTimeConfirm"
                                @cancel="showEndTimePicker = false"
                            />
                        </van-popup>
                    </div>
                </div>
                <!-- 红包金额 -->
                <div class="lesson-time">
                    <span>红包金额：</span>
                    <span v-if="!isEditing">{{
                        courseInfo.train_lesson_red_money || 0
                    }}</span>
                    <van-field
                        v-else
                        v-model="editForm.red_packet_amount"
                        type="number"
                        placeholder="请输入红包金额"
                        class="amount-input"
                    />
                </div>
            </template>
        </div>
        <van-loading
            v-if="isLoading"
            color="#1989fa"
            style="
                position: fixed;
                top: 15%;
                left: 50%;
                transform: translate(-50%, -50%);
            "
        />
        <div v-else class="q-a">
            <div v-if="courseInfo.question" class="q-a-context">
                <div class="q-a-context-title">有奖答题</div>
                <div class="q-a-context-diver"></div>
                <div
                    v-for="(question, index1) in courseInfo.question"
                    :key="'c_q_' + index1"
                >
                    <div class="q-a-context-topic layout-left-center">
                        <div class="layout-center q-a-context-topic-l" style="">
                            单选题
                        </div>
                        {{ question.question_id }}.{{ question.question_title }}
                    </div>
                    <div
                        v-for="(item, index) in question.question_option_json"
                        :key="'item_' + index"
                    >
                        <div
                            class="q-a-context-option layout-left-center"
                            :class="[
                                item.answer_checked === '1'
                                    ? 'q-a-context-option-select'
                                    : '',
                            ]"
                        >
                            <div>{{ String.fromCharCode(65 + index) }}</div>
                            |
                            <div style="position: relative">
                                {{ item.option }}
                            </div>
                            <van-icon
                                style="
                                    position: absolute;
                                    right: var(--base-px-36);
                                "
                                v-if="item.answer_checked === '1'"
                                name="success"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <van-empty image="error" description="暂无课程数据" />
            </div>
        </div>
    </div>
</template>
<script>
import { lessonDetails, updateLessonDetails } from "@/api/course";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import VideoPlayer from "@/views/course/videoPlayer.vue";
import { Toast } from "vant";

export default {
    name: "courseDetails",
    components: { VideoPlayer },
    data() {
        return {
            courseInfo: {},
            selectOption: [],
            selectOptionNum: 0,
            player: null,
            isLoading: true,
            isEditing: false,
            editForm: {
                start_time: "",
                end_time: "",
                red_packet_amount: "",
            },
            showStartTimePicker: false,
            showEndTimePicker: false,
            startTimeDate: new Date(),
            endTimeDate: new Date(),
            is_recharge_type: process.env.VUE_APP_IS_RECHARGE_TYPE,
			userDatalt:{}
        };
    },
    created() {
		this.userDetails()
        this.getDetail();
    },
    mounted() {},
    methods: {
		userDetails() {
            const item = JSON.parse(localStorage.getItem("userDetails"));
            if (item) {
                this.userDatalt = item;
            }
        },
        getDetail() {
            const { id, train_lesson_id } = this.$route.query;
            lessonDetails({
                lesson_id: String(id),
                train_lesson_id: String(train_lesson_id),
            })
                .then((res) => {
                    if (res.code == 1) {
                        console.log(res.data);
                        this.selectOption = [];
                        res.data.question.forEach((q) => {
                            this.selectOption.push({
                                option: "",
                            });
                            q.question_option_json = JSON.parse(
                                q.question_option_json
                            );
                        });
                        res.data.question.sort((a, b) => {
                            return a.question_id - b.question_id;
                        });
                        this.courseInfo = res.data;
                        // 初始化编辑表单数据
                        this.initEditForm();
                        console.log(this.courseInfo);
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        back() {
            this.$router.back();
        },
        onSelectOption(item) {
            this.selectOption = item;
        },
        onSubmit() {
            console.log(this.courseInfo.question_option_json);
        },
        handlePlayStart() {
            console.log("视频开始播放");
            // 这里可以添加父组件的处理逻辑
        },
        handlePlayEnd() {
            console.log("视频播放结束");
            // 这里可以添加父组件的处理逻辑
        },
        // 初始化编辑表单
        initEditForm() {
            this.editForm.start_time =
                this.courseInfo.train_lesson_start_time || "";
            this.editForm.end_time =
                this.courseInfo.train_lesson_end_time || "";
            this.editForm.red_packet_amount =
                this.courseInfo.train_lesson_red_money || "";

            // 初始化日期选择器的值
            if (this.courseInfo.train_lesson_start_time) {
                const startDate = new Date(
                    this.courseInfo.train_lesson_start_time
                );
                this.startTimeDate = isNaN(startDate.getTime())
                    ? new Date()
                    : startDate;
            } else {
                this.startTimeDate = new Date();
            }
            if (this.courseInfo.train_lesson_end_time) {
                const endDate = new Date(this.courseInfo.train_lesson_end_time);
                this.endTimeDate = isNaN(endDate.getTime())
                    ? new Date()
                    : endDate;
            } else {
                this.endTimeDate = new Date();
            }
        },
        // 切换编辑状态
        toggleEdit() {
            if (this.isEditing) {
                // 完成编辑，提交数据
                this.submitEdit();
            } else {
                // 进入编辑状态
                this.isEditing = true;
                this.initEditForm();
            }
        },
        cancelEdit() {
            this.isEditing = false;
            this.getDetail();
        },
        // 开始时间选择确认
        onStartTimeConfirm(value) {
            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hour = String(date.getHours()).padStart(2, "0");
            const minute = String(date.getMinutes()).padStart(2, "0");
            const second = String(date.getSeconds()).padStart(2, "0");
            this.editForm.start_time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
            this.showStartTimePicker = false;
        },
        // 结束时间选择确认
        onEndTimeConfirm(value) {
            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hour = String(date.getHours()).padStart(2, "0");
            const minute = String(date.getMinutes()).padStart(2, "0");
            const second = String(date.getSeconds()).padStart(2, "0");
            this.editForm.end_time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
            this.showEndTimePicker = false;
        },
        formatter(type, val) {
            if (type === "year") {
                return `${val}年`;
            } else if (type === "month") {
                return `${val}月`;
            } else if (type === "day") {
                return `${val}日`;
            } else if (type === "hour") {
                return `${val}时`;
            } else if (type === "minute") {
                return `${val}分`;
            } else if (type === "second") {
                return `${val}秒`;
            }
            return val;
        },
        // 提交编辑
        submitEdit() {
            // 验证数据
            if (!this.editForm.start_time) {
                Toast({ position: "top", message: "请选择开始时间" });
                return;
            }
            if (!this.editForm.end_time) {
                Toast({ position: "top", message: "请选择结束时间" });
                return;
            }
            if (this.editForm.start_time >= this.editForm.end_time) {
                Toast({ position: "top", message: "结束时间必须晚于开始时间" });
                return;
            }
            if (
                this.editForm.red_packet_amount === "" ||
                this.editForm.red_packet_amount === null ||
                this.editForm.red_packet_amount === undefined
            ) {
                Toast({ position: "top", message: "请输入红包金额" });
                return;
            }

            // 提交数据
            const { train_lesson_id } = this.$route.query;
            const submitData = {
                train_lesson_id: train_lesson_id,
                start_time: this.editForm.start_time,
                end_time: this.editForm.end_time,
                red_money: this.editForm.red_packet_amount,
            };

            updateLessonDetails(submitData)
                .then((res) => {
                    if (res.code == 1) {
                        Toast.success("更新成功");
                        // 退出编辑状态
                        this.isEditing = false;
                        this.getDetail();
                    } else {
                        Toast.fail(res.msg || "更新失败");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    Toast.fail("更新失败，请重试");
                });
        },
    },
};
</script>
<style scoped lang="less">
.index {
    font-size: var(--base-px-14);
    min-height: 100%;
    background-color: #f2f3f7;
    width: 100%;

    .video-container {
        width: 100%;
        height: var(--base-px-214);
        margin: 0 auto;
    }

    button {
        background: transparent;
        color: white;
        border: none;
        padding: var(--base-px-8) var(--base-px-12);
        border-radius: var(--base-px-4);
        font-size: var(--base-px-16);
    }

    .lesson-title {
        font-weight: 400;
        font-size: var(--base-px-16);
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: #ffffff;
        border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8)
            var(--base-px-8);
        padding: var(--base-px-12);
    }

    .q-a {
        padding: var(--base-px-12);
    }

    .q-a-context {
        background: #ffffff;
        border-radius: var(--base-px-16) var(--base-px-16) var(--base-px-16)
            var(--base-px-16);
        padding: var(--base-px-16);

        &-title {
            font-weight: bold;
            font-size: var(--base-px-16);
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        &-diver {
            border: var(--base-px-1) solid #dbdbdb;
            margin-top: var(--base-px-12);
        }

        &-topic {
            padding-top: var(--base-px-12);
            font-weight: 400;
            font-size: var(--base-px-14);
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;

            &-l {
                height: var(--base-px-18);
                width: var(--base-px-53);
                background: #1a89f9;
                border-radius: var(--base-px-2) var(--base-px-10)
                    var(--base-px-2) var(--base-px-10);
                font-size: var(--base-px-11);
                color: #ffffff;
            }
        }

        &-option {
            background: #f9f9f9;
            border-radius: var(--base-px-8);
            padding: 0 var(--base-px-16);
            height: var(--base-px-40);
            margin-top: var(--base-px-12);
            font-weight: 400;
            font-size: var(--base-px-14);
        }

        &-option-select {
            background: #1a89f9;
            color: #ffffff;
        }

        &-submit {
            margin-top: var(--base-px-32);
            width: var(--base-px-304);
            height: var(--base-px-64);
            border-radius: var(--base-px-16) var(--base-px-16) var(--base-px-16)
                var(--base-px-16);
            border: var(--base-px-2) solid #1a89f9;
            font-weight: 400;
            font-size: 28rpx;
            color: #1a89f9;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }
    }

    .video-player {
        position: relative;
        width: 100%;
        background-color: #000;
    }

    video {
        width: 100%;
        display: block;
    }

    .controls {
        display: flex;
        align-items: center;
        padding: var(--base-px-8) var(--base-px-12);
        background-color: rgba(0, 0, 0, 0.7);
    }

    .control-btn {
        padding: var(--base-px-8);
        color: white;
        font-size: var(--base-px-18);
    }

    .progress-display {
        flex: 1;
        display: flex;
        align-items: center;
        margin: 0 var(--base-px-10);
        color: white;
        font-size: var(--base-px-12);
    }

    .progress-bar {
        flex: 1;
        height: var(--base-px-4);
        margin: 0 var(--base-px-10);
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: var(--base-px-2);
        position: relative;
    }

    .progress {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: #007aff;
        border-radius: var(--base-px-2);
    }
}
.lesson-time {
    width: 100%;
    padding-top: var(--base-px-6);
    font-size: var(--base-px-13);
    padding-bottom: var(--base-px-2);
    display: flex;
    align-items: center;
}
.time-input-wrapper {
    flex: 1;
    margin-left: var(--base-px-10);
}
.time-input {
    padding: 0;
    height: var(--base-px-32);
    background: #f5f7f7;
    border-radius: var(--base-px-4);
}
.amount-input {
    flex: 1;
    margin-left: var(--base-px-10);
    padding: 0;
    height: var(--base-px-32);
    background: #f5f7f7;
    border-radius: var(--base-px-4);
}
.lesson-edit {
    width: var(--base-px-64);
    height: var(--base-px-32);
    background-color: #007aff;
    color: #ffffff;
    border-radius: var(--base-px-4);
    text-align: center;
    line-height: var(--base-px-32);
    font-size: var(--base-px-14);
    cursor: pointer;
}
.lesson-cancel {
    width: var(--base-px-64);
    height: var(--base-px-32);
    background-color: #e42d2d;
    color: #ffffff;
    border-radius: var(--base-px-4);
    text-align: center;
    line-height: var(--base-px-32);
    font-size: var(--base-px-14);
    cursor: pointer;
	margin-left: var(--base-px-14);
}
/deep/ .van-field__body {
    height: 100%;
    padding-left: 10px;
}
</style>
